import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Navigation } from '@pkg/components/Navigation';

import './_PageNotFound.scss';

interface Props {
    hideGlobalNav?: boolean;
}

export default function PageNotFound({ hideGlobalNav }: Props) {
    const { t } = useTranslation(['common', 'power_ups']);

    const errorPageMarkup = (
        <div data-testid="page-not-found" className="not-found">
            <img className="not-found-graphic" src="/assets/img/empty@2x.png" alt={t('power_ups:ghost_bg_alt')} />
            <div>
                <h1 className="not-found-copy">{t('not_found_page_copy')}</h1>

                <Link to="/">
                    <img
                        src="/src/assets/brand/yat-hand-purple-outline.svg"
                        className="not-found-logo"
                        alt={t('logo')}
                    />
                </Link>
            </div>
        </div>
    );

    return !hideGlobalNav ? (
        <Navigation hideBackground displayZIndexTop>
            {errorPageMarkup}
        </Navigation>
    ) : (
        errorPageMarkup
    );
}
